//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    brigadeVehicles: {
      type: Array,
      default: () => []
    },
    filled: {
      type: Boolean,
      default: false
    },
    vehicleId: {
      type: Number,
      default: null
    }
  },
  computed: {
    trackersData: function () {
      const data = []
      if (this.brigadeVehicles) {
        this.brigadeVehicles.forEach(vehicle => {
          if (vehicle.geoTracker && (!this.vehicleId || this.vehicleId === vehicle.id)) {
            data.push({
              tracker: vehicle.geoTracker,
              name: vehicle.name,
              gosNumber: vehicle.gosNumber
            })
          }
        })
      }
      return data
    }
  }
}
